/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './PersonalizedServices.scss';

import { bool, object } from 'prop-types';
import React from 'react';

import PersonalizedServicesCard from './PersonalizedServicesCard';
import {
  ALASKA_529,
  ALASKA_529_ONLY,
  COLLEGE_SAVINGS_ACCOUNTS,
  MARYLAND_529,
  personalizedServices,
  education,
  tuition,
  video
} from './PersonalizedServiceConfig';
import MarylandMatchCard from './MarylandMatchCard';
import { educationPlanningCenterDisabled } from 'services/FeatureFlags';


const PersonalizedCollectionCards = ({ view, productTypes, stacked }) => {

  return productTypes.map((collegeProduct, i) => {
    const title = COLLEGE_SAVINGS_ACCOUNTS.filter(
      (csa) => csa.account === collegeProduct
    );
    return (
      <div
        key={`card${i}`}
        className={
          stacked ? 'personalized-services' : 'personalized-services-plus'
        }>
        {!stacked && (
          <div className="personalized-services-plus-title">
            {title && title[0] && title[0]['title'] ? title[0]['title'] : ''}
          </div>
        )}
        <div className="personalized-services-plus-cards">
          {collegeProduct === MARYLAND_529 && (
            <MarylandMatchCard additionalClassName="plus-collection-card" />
          )}
          <PersonalizedServicesCard
            className="personalized-go-tuition"
            {...tuition(view, collegeProduct)}
          />
          <PersonalizedServicesCard
            className="personalized-video-card"
            isVideo
            collegeProduct={collegeProduct}
            {...video(view, collegeProduct)}
          />
          {!educationPlanningCenterDisabled() && (<PersonalizedServicesCard
            className="personalized-education-planning-center"
            isAlaska529={[ALASKA_529_ONLY, ALASKA_529].includes(collegeProduct)}
            isEducation
            {...education(view, collegeProduct)}
          />)}
        </div>
      </div>
    );
  });
};

const PersonalizedServices = ({ view, stacked, isCustodian }) => {

  return (
    <PersonalizedCollectionCards
      view={view}
      productTypes={personalizedServices(view, isCustodian)['productTypes']}
      stacked={stacked}
      isCustodian={isCustodian}
    />
  );
};

PersonalizedServices.propTypes = {
  view: object,
  stacked: bool
};

export default PersonalizedServices;
